export const SMART_WEARABLE_FILTER_DATA_TEST_ID = 'smart-wearable-filter'
